import { render, staticRenderFns } from "./SPopup.vue?vue&type=template&id=3778e14c"
import script from "./SPopup.vue?vue&type=script&lang=js"
export * from "./SPopup.vue?vue&type=script&lang=js"
import style0 from "./SPopup.vue?vue&type=style&index=0&id=3778e14c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports